import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'issue-field-original-estimate-editview-full.original-estimate.label',
		defaultMessage: 'Original estimate',
		description: 'Aria label for accessibility',
	},
});
